"use client";

import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import HistoryItem from "./histories/Item";
import { Button } from "antd";
function AboutIndex({ banners, setting, histories }) {
  const statsRef = useRef(null);
  const aboutUs = JSON.parse(setting?.aboutUs || "{}");
  const [thongKe, setThongKe] = useState({
    kinhNghiem: 0,
    duAn: 0,
    khachHang: 0,
  });
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (!statsRef.current || hasAnimated) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);

          const target = {
            kinhNghiem: parseInt(aboutUs.thongKe?.kinhNghiem) || 0,
            duAn: parseInt(aboutUs.thongKe?.soDuAn) || 0,
            khachHang: parseInt(aboutUs.thongKe?.soKhachHang) || 0,
          };

          const duration = 1000; // 2 seconds
          const startTime = Date.now();

          const animateCounter = () => {
            const now = Date.now();
            const progress = Math.min((now - startTime) / duration, 1);

            setThongKe({
              kinhNghiem: Math.floor(target.kinhNghiem * progress),
              duAn: Math.floor(target.duAn * progress),
              khachHang: Math.floor(target.khachHang * progress),
            });

            if (progress < 1) {
              requestAnimationFrame(animateCounter);
            }
          };

          animateCounter();
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, [hasAnimated, aboutUs?.thongKe]);

  console.log(aboutUs);
  return (
    <div className="overflow-hidden">
      <div className="xl:mt-[80px] xl:mb-[95px] md:mt-[60px] md:mb-[70px] mt-[40px] mb-[50px] px-4">
        <div data-aos="fade-down">
          <h1 className="font-bold text-3xl md:text-5xl xl:text-6xl -mb-2 mr-4 text-center">
            Về <span className="text-[#E5C383]">Chúng Tôi</span>
          </h1>
        </div>
        <div className="mt-6" data-aos="fade-up">
          <div className="xl:text-2xl md:text-xl text-base text-[#585858] text-center max-w-4xl mx-auto">
            <div
              dangerouslySetInnerHTML={{
                __html: aboutUs?.veChungToiMoTa || "",
              }}
            />
          </div>
        </div>
      </div>

      <div data-aos="zoom-in" className="overflow-hidden">
        <img
          src={banners[0].thumbnail}
          className="w-full object-cover max-h-[500px] md:max-h-none"
          alt="Vạn Xuân Banner"
        />
      </div>

      <div
        id="ab_us"
        className="ab-us bg-[#F1FAFE] xl:h-screen w-full flex xxl:flex-row flex-col justify-between items-center overflow-hidden relative gap-y-8"
      >
        <div className="container grid lg:grid-cols-12 items-center lg:h-screen us_info lg:px-6 px-4 py-10 lg:py-0 p-[30px]">
          <div className="bg-[url('/images/logo_white_large.png')] w-auto h-auto xl:w-[664px] xl:h-[628px] xl:left-[500px] top-0 absolute bg-no-repeat hidden lg:block" />
          <div
            data-aos="fade-right"
            data-aos-anchor-placement="top"
            className="col-span-12 lg:col-span-5 lg:z-10"
          >
            <p className="text-[#2CADE3] text-sm md:text-lg font-semibold uppercase mb-2 md:mb-[15px]">
              new information
            </p>
            <div>
              <span className="font-bold text-2xl md:text-3xl xl:text-6xl -mb-2 mr-4">
                Về <span className="text-[#E5C383]">Chúng Tôi</span>
              </span>
            </div>
            <div className="flex flex-col gap-y-4 md:gap-y-6 mt-4 md:mt-8 mb-4 md:mb-12 font-normal text-base md:text-xl xl:text-2xl">
              <div
                className="text-justify text-[#546475]"
                dangerouslySetInnerHTML={{
                  __html: aboutUs?.veChungToiMoTa || "",
                }}
              />
            </div>
            <div className="grid grid-cols-3 gap-2 md:gap-4" ref={statsRef}>
              <div
                className="py-3 md:py-[26px] px-2 md:px-[18px] bg-white rounded-lg"
                style={{ boxShadow: "0px 4px 29.3px 0px #00000040" }}
              >
                <img
                  src="/svg/reward.svg"
                  className="w-6 md:w-auto"
                  alt="Kinh nghiệm"
                />
                <h2 className="mt-2 md:mt-[28px] text-lg md:text-[28px] font-bold">
                  {thongKe?.kinhNghiem || "0"}+
                </h2>
                <p className="mt-1 md:mt-[14px] text-[#323232] text-xs md:text-xl">
                  Kinh nghiệm
                </p>
              </div>
              <div
                className="py-3 md:py-[26px] px-2 md:px-[18px] bg-white rounded-lg"
                style={{ boxShadow: "0px 4px 29.3px 0px #00000040" }}
              >
                <img
                  src="/svg/user-setting.svg"
                  className="w-6 md:w-auto"
                  alt="Dự án"
                />
                <h2 className="mt-2 md:mt-[28px] text-lg md:text-[28px] font-bold">
                  {thongKe?.duAn || "0"}+
                </h2>
                <p className="mt-1 md:mt-[14px] text-[#323232] text-xs md:text-xl">
                  Dự án
                </p>
              </div>
              <div
                className="py-3 md:py-[26px] px-2 md:px-[18px] bg-white rounded-lg"
                style={{ boxShadow: "0px 4px 29.3px 0px #00000040" }}
              >
                <img
                  src="/svg/user-like.svg"
                  className="w-6 md:w-auto"
                  alt="Khách hàng"
                />
                <h2 className="mt-2 md:mt-[28px] text-lg md:text-[28px] font-bold">
                  {thongKe?.khachHang || "0"}+
                </h2>
                <p className="mt-1 md:mt-[14px] text-[#323232] text-xs md:text-xl">
                  Khách hàng
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-left"
          className="skew-box lg:absolute top-0 lg:flex grid grid-cols-3 right-6 text-white xl:text-4xl text-base font-extrabold lg:w-auto w-full lg:h-full"
        >
          <Link
            href="/ve-chung-toi"
            style={{
              backgroundImage: `url(${aboutUs?.giaTriCotLoi?.[0]?.hinhAnh || "/images/test/2.jpg"})`,
            }}
            className={`lg:w-44 xl:w-62 xxl:w-80 w-full h-32 sm:h-40 md:h-60 lg:h-full bg-center bg-cover lg:-skew-x-6 overflow-hidden flex justify-center items-end relative skew-item`}
          >
            <div className="flex md:flex-row flex-col gap-x-2 xl:gap-x-3 items-center z-20 py-2 md:py-4 xl:py-16 px-0 xl:px-4 skew-text">
              <div>
                <div className="text-xs sm:text-sm md:text-base xl:text-2xl uppercase whitespace-nowrap font-bold xxl:text-3xl">
                  {aboutUs?.giaTriCotLoi[0]?.ten}
                </div>
              </div>
            </div>
            <div className="absolute top-0 right-0 bottom-0 left-0 opacity-0 z-10 bg-hover skew-mask w-full" />
          </Link>
          <Link
            href="/ve-chung-toi"
            style={{
              backgroundImage: `url(${aboutUs?.giaTriCotLoi?.[1]?.hinhAnh || "/images/test/3.jpg"})`,
            }}
            className={`lg:w-44 xl:w-62 xxl:w-80 w-full h-32 sm:h-40 md:h-60 lg:h-full bg-center bg-cover lg:-skew-x-6 overflow-hidden flex justify-center items-end relative skew-item`}
          >
            <div className="flex md:flex-row flex-col items-center gap-x-2 xl:gap-x-3 justify-center z-20 py-2 md:py-4 xl:py-16 px-2 xl:px-4 skew-text">
              <div>
                <div className="text-xs sm:text-sm md:text-base xl:text-2xl uppercase whitespace-nowrap font-bold xxl:text-3xl">
                  {aboutUs?.giaTriCotLoi[1]?.ten}
                </div>
              </div>
            </div>
            <div className="absolute top-0 right-0 bottom-0 left-0 opacity-0 z-10 bg-hover skew-mask w-full" />
          </Link>
          <Link
            href="/ve-chung-toi"
            style={{
              backgroundImage: `url(${aboutUs?.giaTriCotLoi?.[2]?.hinhAnh || "/images/test/4.jpg"})`,
            }}
            className={`lg:w-44 xl:w-62 xxl:w-80 w-full h-32 sm:h-40 md:h-60 lg:h-full bg-center bg-cover lg:-skew-x-6 overflow-hidden flex justify-center items-end relative skew-item`}
          >
            <div className="flex md:flex-row flex-col gap-x-2 xl:gap-x-3 items-center z-20 py-2 md:py-4 xl:py-16 px-2 xl:px-4 skew-text">
              <div>
                <div className="text-xs sm:text-sm md:text-base xl:text-2xl uppercase whitespace-nowrap font-bold xxl:text-3xl">
                  {aboutUs?.giaTriCotLoi[2]?.ten}
                </div>
              </div>
            </div>
            <div className="absolute top-0 right-0 bottom-0 left-0 opacity-0 z-10 bg-hover skew-mask w-full" />
          </Link>
        </div>
      </div>

      <div className="container my-[60px] md:my-[100px] xl:my-[120px] px-4 xl:px-0">
        <div
          className="flex flex-col md:flex-row gap-6 md:gap-8 items-center"
          data-aos="fade-right"
        >
          <img
            src="/images/test/about/2.png"
            className="w-full md:w-1/2 h-[250px] md:h-[350px] xl:h-[400px] object-cover rounded-lg"
            alt="Tầm nhìn"
            data-aos="zoom-in"
          />
          <div className="w-full md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl md:text-3xl xl:text-4xl uppercase text-[#1658A7] font-bold">
              Tầm nhìn
            </h2>
            <p className="text-base md:text-lg xl:text-xl font-medium mt-4 md:mt-8 text-[#585858]">
              {aboutUs?.tamNhin || ""}
            </p>
          </div>
        </div>

        <div
          className="flex flex-col-reverse md:flex-row gap-6 md:gap-8 items-center mt-[60px] md:mt-[80px] xl:mt-[100px]"
          data-aos="fade-left"
        >
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <h2 className="text-2xl md:text-3xl xl:text-4xl uppercase text-[#1658A7] font-bold">
              SỨ MỆNH
            </h2>
            <p className="text-base md:text-lg xl:text-xl font-medium mt-4 md:mt-8 text-[#585858]">
              {aboutUs?.suMenh || ""}
            </p>
          </div>
          <img
            src="/images/test/about/3.png"
            className="w-full md:w-1/2 h-[250px] md:h-[350px] xl:h-[400px] object-cover rounded-lg"
            alt="Sứ mệnh"
            data-aos="zoom-in"
          />
        </div>
      </div>

      <div className="bg-[url('/images/test/about/4.jpg')] relative bg-cover bg-center bg-no-repeat w-full overflow-hidden">
        <div
          style={{
            background:
              "linear-gradient(247.78deg, rgba(0, 78, 179, 0.7) -1.18%, #030432 101.31%),linear-gradient(178.81deg, rgba(255, 255, 255, 0) 1.05%, #FFFFFF 92.7%, rgba(255, 255, 255, 0.9) 92.7%)",
          }}
          className="flex flex-col justify-center items-center py-10 md:py-[100px] md:pt-[150px] px-4"
        >
          <h2
            className="font-semibold text-3xl md:text-5xl xl:text-6xl text-white mb-6 md:mb-[38px] text-center"
            data-aos="fade-down"
          >
            Sơ đồ tổ chức
          </h2>
          <div
            data-aos="zoom-in"
            data-aos-delay="300"
            className="w-full overflow-x-auto"
          >
            <img
              src={aboutUs?.soDoToChuc || ""}
              className=" object-cover mx-auto"
              alt="Sơ đồ tổ chức"
            />
          </div>
        </div>
      </div>

      <div className="bg-center z-10 bg-no-repeat bg-cover w-full h-fit relative mt-10 xl:mb-[150px] md:mb-[120px] mb-[80px] flex flex-col justify-center px-4 xl:px-0 xl:pb-0 pb-8">
        <div
          className="flex flex-col items-center justify-center pb-8 md:pb-16 mt-6 md:mt-10"
          data-aos="fade-down"
        >
          <span className="text-2xl md:text-4xl xl:text-6xl font-semibold text-center">
            Lịch sử hình thành
          </span>
        </div>
        <div className="max-w-[1100px] w-max mx-auto overflow-x-auto overflow-y-hidden py-4">
          <div className="flex md:flex-row md:w-max w-auto flex-col justify-between gap-4 md:gap-0">
            {histories.map((history, index) => (
              <div
                key={history.id}
                data-aos="fade-up"
                data-aos-delay={index * 150}
              >
                <HistoryItem
                  index={index + 1}
                  history={history}
                  length={histories.length}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-[url('/images/test/l1.jpg')] relative bg-center bg-cover bg-no-repeat w-full overflow-hidden">
        <div className="bg-[#051641CC] flex flex-col justify-center items-center py-10 md:py-[100px] md:pt-[100px] px-4">
          <div className="container relative z-0 overflow-hidden flex flex-col items-center gap-y-6 md:gap-y-16">
            <div data-aos="fade-up" className="text-center">
              <h2 className="text-2xl md:text-4xl xl:text-6xl font-semibold text-white">
                Sẵn sàng bắt đầu dự án của bạn?
              </h2>
              <p className="text-base md:text-lg xl:text-xl text-[#D1D5DC] mt-4 md:mt-[23px] max-w-2xl mx-auto">
                Liên hệ với chúng tôi ngay hôm nay để nhận tư vấn miễn phí từ
                đội ngũ chuyên gia.
              </p>
              <div className="mt-6 md:mt-[33px] flex flex-col sm:flex-row gap-4 mx-auto justify-center">
                <Link href={`/lien-he#tu-van`}>
                  <Button
                    size="large"
                    shape="round"
                    type="primary"
                    className="!py-3 md:!py-4 !px-6 md:!px-10 !h-[44px] md:!h-[50px] !text-black !font-medium !text-sm md:!text-base"
                  >
                    Nhận tư vấn ngay
                  </Button>
                </Link>
                <a href={`tel:${aboutUs?.soDienThoai}`}>
                  <Button
                    size="large"
                    shape="round"
                    ghost
                    className="!py-3 md:!py-4 !px-6 md:!px-10 !h-[44px] md:!h-[50px] !text-white !font-medium !border-[2px] !text-sm md:!text-base"
                  >
                    Gọi: {aboutUs?.soDienThoai || ""}
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutIndex;
